import {Routes} from '@angular/router';
import {IndexComponent} from './index/index';

export const routes:Routes=[
	{
		path:'error',
		loadComponent:()=>import('./misc/components/error/error').then((m)=>m.ErrorComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'',
		component:IndexComponent,
		pathMatch:'full'
	},
	{
		path:'contact',
		loadComponent:()=>
			import('./contact/contact').then((m)=>m.ContactComponent),
		data:{preload:true}
	},
	{
		path:'privacy-policy',
		loadComponent:()=>
			import('./privacy-policy/privacy-policy').then((m)=>m.PrivacyPolicyComponent),
		data:{preload:true}
	},
	{
		path:'terms-of-use',
		loadComponent:()=>
			import('./terms-of-use/terms-of-use').then((m)=>m.TermsOfUseComponent),
		data:{preload:true}
	},
	{
		path:'medicina-biorreguladora',
		loadComponent:()=>
			import('./medicina-biorreguladora/medicina-biorreguladora').then(
				(m)=>m.MedicinaBiorreguladoraComponent
			),
		data:{preload:true}
	},
	{
		path:'sueroterapia-autosanguis',
		loadComponent:()=>
			import('./sueroterapia-autosanguis/sueroterapia-autosanguis').then(
				(m)=>m.SueroterapiaAutosanguisComponent
			),
		data:{preload:true}
	},
	{
		path:'**',
		loadComponent:()=>
			import('./misc/components/not-found/not-found').then((m)=>m.NotFoundComponent),
		pathMatch:'full',
		data:{preload:true}
	}
];
